module.exports = __webpack_public_path__ + "img/NW14.f535b56c.gif";